import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const numberStepperStyleId = 'wb-v2-number-stepper-theme';

export const numberStepperBridgeStyles = {
  'wb-number-stepper': {
    '--local-stepper-bg': tokens.color.background.primary,
    '--local-stepper-border': tokens.color.border.primary,
    '--local-stepper-radius': tokens.radius.sm,
    '--local-stepper-divider': tokens.color.border.secondary,
    '--local-stepper-focus-ring': tokens.focusRing.default,
    '--local-stepper-segment-size': '28px',
    '--local-stepper-value-min-width': '32px',
    '--local-stepper-action-color': tokens.color.foreground.brandPrimary,
    '--local-stepper-action-hover-bg': tokens.color.background.secondary,
    '--local-stepper-action-disabled-color': tokens.color.text.disabled,
    '--local-stepper-action-font-size': tokens.font.size.textSm,
    '--local-stepper-value-color': tokens.color.text.primary,
    '--local-stepper-value-disabled-color': tokens.color.text.disabled,
    '--local-stepper-value-font-family': tokens.font.family.body,
    '--local-stepper-value-font-size': tokens.font.size.textMdBase,
    '--local-stepper-value-font-weight': tokens.font.weight.semibold,
    '--local-stepper-value-line-height': tokens.lineHeight.textMd,
  },
};
